import { Action, ActionColumnsProps } from './interfaces/ActionsColumn'

import Button from '../../../../CustomButtons/Button'
import React from 'react'
import { Tooltip } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const ActionsColumn = ({ actions }: ActionColumnsProps) => {
  const { t } = useTranslation()
  
  return (
    <div className="appointments-actions">
      {actions.map((obj: Action) => {
        const title = t(obj.tooltipLabel)
        return (
          <div className="appointments-actions" key={obj.type}>
              <Tooltip title={title}>
                <span>
                  <Button
                    simple
                    justIcon
                    color={obj.color}
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault()
                      obj.onClick()
                    }}
                  >
                    {obj.icon}
                  </Button>
                </span>
              </Tooltip>
          </div>
        )
      })}
    </div>
  )
}
